"use strict";Object.defineProperty(exports, "__esModule", {value: true});



















var _I4CBIWTXcjs = require('../__chunks/I4CBIWTX.cjs');




















exports.canUseDOM = _I4CBIWTXcjs.canUseDOM; exports.contains = _I4CBIWTXcjs.contains; exports.getActiveElement = _I4CBIWTXcjs.getActiveElement; exports.getDocument = _I4CBIWTXcjs.getDocument; exports.getPopupItemRole = _I4CBIWTXcjs.getPopupItemRole; exports.getPopupRole = _I4CBIWTXcjs.getPopupRole; exports.getScrollingElement = _I4CBIWTXcjs.getScrollingElement; exports.getTextboxSelection = _I4CBIWTXcjs.getTextboxSelection; exports.getTextboxValue = _I4CBIWTXcjs.getTextboxValue; exports.getWindow = _I4CBIWTXcjs.getWindow; exports.isButton = _I4CBIWTXcjs.isButton; exports.isFrame = _I4CBIWTXcjs.isFrame; exports.isPartiallyHidden = _I4CBIWTXcjs.isPartiallyHidden; exports.isTextField = _I4CBIWTXcjs.isTextField; exports.isTextbox = _I4CBIWTXcjs.isTextbox; exports.isVisible = _I4CBIWTXcjs.isVisible; exports.scrollIntoViewIfNeeded = _I4CBIWTXcjs.scrollIntoViewIfNeeded; exports.setSelectionRange = _I4CBIWTXcjs.setSelectionRange; exports.sortBasedOnDOMPosition = _I4CBIWTXcjs.sortBasedOnDOMPosition;
